import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDyTripPlanIsNoAddressNeeded } from "./is-no-address-needed";
import { QuestionDayTripPlanIsChangeOnlyOption } from "./is-only-change-option";
import { QuestionDayTripPlanIsRequest } from "./is-request";
import { QuestionDayTripPlanIsSecret } from "./is-secret";
import { QuestionDayTripPlanIsUncancelable } from "./is-uncancelable";
import { QuestionDayTripPlanIsUnchangeable } from "./is-unchangeable";
import { QuestionDayTripPlanMealConditions } from "./meal-conditions";
import { QuestionDayTripPlanOnlyUseCreditPayment } from "./only-use-credit-payment";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	planAttributes: DayTripPlanCategoriesAndManagerStore["planAttributes"];
};

export const QuestionDayTripPlanAttributes = ({ planAttributes }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="予約方法に関する制限" categoryStore={planAttributes}>
				<QuestionDayTripPlanOnlyUseCreditPayment />
				<QuestionDayTripPlanIsRequest />
				<QuestionDayTripPlanIsUnchangeable />
				<QuestionDayTripPlanIsUncancelable />
				<QuestionDayTripPlanIsChangeOnlyOption />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="予約情報に関する設定" categoryStore={planAttributes}>
				<QuestionDyTripPlanIsNoAddressNeeded />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="食事に関する設定" categoryStore={planAttributes}>
				<QuestionDayTripPlanMealConditions />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="シークレットプランの設定" categoryStore={planAttributes}>
				<QuestionDayTripPlanIsSecret />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionDayTripPlanAttributes.displayName = "QuestionDayTripPlanAttributes";
